import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const SpeakerIcon = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 80.7 59.97" {...props}>
    <path d="M25.42,18.44H5.61v30.29h12.24v-7.2h7.57l27.98,16.2V2.24L25.42,18.44Zm-10.35,20.32v7.2h-6.68V21.22H25.41v17.53H15.07Zm35.55-9.46v23.63l-22.04-12.76V19.82L50.62,7.06V29.29Z" />
    <g>
      <rect x="66.22" y="28.49" width="8.87" height="3" />
      <rect
        x="63.52"
        y="42.9"
        width="3"
        height="8.87"
        transform="translate(-7.17 82.78) rotate(-62.21)"
      />
      <rect
        x="60.59"
        y="12.57"
        width="8.87"
        height="3"
        transform="translate(.94 31.93) rotate(-27.78)"
      />
    </g>
  </SvgIcon>
));

export default React.memo(SpeakerIcon);
